// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".budget-tree .mobile-display{display:none}@media screen and (max-width: 767px){.budget-tree .mobile-display{display:block}.budget-tree .scrolltable-x{display:none}}\n", ""]);
// Exports
module.exports = exports;
